import { Component, Input } from '@angular/core';
import { Table } from '../../../../models/reporting';

@Component({
    selector: 'detailed-matrix-table',
    templateUrl: './detailed-matrix-table.component.html',
    styleUrls: ['./table.component.scss']
})
export class DetailedMatrixTableComponent {
    @Input() table: Table;
}
